type InvoiceTotalsLine = {
  quantity: number
  unitPriceHT: number
  rate: number
}

const roundAmount = (amount: number): number =>
  (Math.sign(amount) * Math.round((Math.abs(amount) + Number.EPSILON) * 100)) /
  100

export const computeLineTotalHT = ({
  quantity,
  unitPriceHT
}: Pick<InvoiceTotalsLine, 'quantity' | 'unitPriceHT'>): number =>
  roundAmount(quantity * unitPriceHT)

const computeLineTotalTTC = (line: InvoiceTotalsLine): number => {
  const totalHT = computeLineTotalHT(line)
  return roundAmount(totalHT + totalHT * (line.rate / 100))
}

export const computeInvoiceTotals = (
  lines: InvoiceTotalsLine[]
): { totalHT: number; totalTTC: number } => {
  let totalHT = 0
  let totalTTC = 0

  for (const line of lines) {
    totalHT += computeLineTotalHT(line)
    totalTTC += computeLineTotalTTC(line)
  }

  return { totalHT: roundAmount(totalHT), totalTTC: roundAmount(totalTTC) }
}
